interface IconProps {
  fillColor: string
  isMobile?: boolean
}

export const AlreadyUsedErrorIcon = ({ fillColor, isMobile }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      {isMobile ? (
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
        >
          <path
            d="M50.0002 18.3331C50.9206 18.3331 51.6668 17.5869 51.6668 16.6664C51.6668 15.7459 50.9206 14.9997 50.0002 14.9997C49.0797 14.9997 48.3335 15.7459 48.3335 16.6664C48.3335 17.5869 49.0797 18.3331 50.0002 18.3331Z"
            fill={fillColor}
          />
          <path
            d="M41.9167 84.9998C41.9167 84.2174 42.5509 83.5831 43.3333 83.5831H56.6667C57.4491 83.5831 58.0833 84.2174 58.0833 84.9998C58.0833 85.7822 57.4491 86.4164 56.6667 86.4164H43.3333C42.5509 86.4164 41.9167 85.7822 41.9167 84.9998Z"
            fill={fillColor}
          />
          <path
            d="M50.1169 58.329C49.1986 58.3934 48.4021 57.7012 48.3377 56.783C48.2733 55.8648 48.9655 55.0682 49.8837 55.0039C50.802 54.9395 51.5985 55.6317 51.6629 56.5499C51.7273 57.4681 51.0351 58.2647 50.1169 58.329Z"
            fill={fillColor}
          />
          <path
            d="M51.4168 44.9997C51.4168 44.2173 50.7826 43.5831 50.0002 43.5831C49.2178 43.5831 48.5835 44.2173 48.5835 44.9997V51.6664C48.5835 52.4488 49.2178 53.0831 50.0002 53.0831C50.7826 53.0831 51.4168 52.4488 51.4168 51.6664V44.9997Z"
            fill={fillColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.9394 33.3781C48.2997 31.0958 51.7006 31.0958 53.0609 33.3781L67.8547 58.1979C69.2151 60.4802 67.5146 63.3331 64.7939 63.3331H35.2064C32.4857 63.3331 30.7853 60.4802 32.1456 58.1979L46.9394 33.3781ZM50.6271 34.8288L65.4209 59.6486C65.4882 59.7614 65.5013 59.8467 65.5001 59.912C65.4987 59.9867 65.4766 60.0773 65.4209 60.1707C65.3133 60.3512 65.111 60.4997 64.7939 60.4997H35.2064C34.8894 60.4997 34.687 60.3512 34.5794 60.1707C34.5238 60.0773 34.5016 59.9867 34.5002 59.912C34.4991 59.8467 34.5122 59.7614 34.5794 59.6486L49.3732 34.8288C49.4902 34.6325 49.7019 34.4997 50.0002 34.4997C50.2985 34.4997 50.5102 34.6325 50.6271 34.8288Z"
            fill={fillColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.25 84.9997C25.25 88.5435 28.1228 91.4163 31.6667 91.4163H68.3333C71.8772 91.4163 74.75 88.5435 74.75 84.9997L74.75 14.9997C74.75 11.4558 71.8772 8.58301 68.3333 8.58301H31.6667C28.1228 8.58301 25.25 11.4559 25.25 14.9997V84.9997ZM31.6667 88.583C29.6876 88.583 28.0833 86.9787 28.0833 84.9997L28.0833 14.9997C28.0833 13.0207 29.6876 11.4163 31.6667 11.4163L68.3333 11.4163C70.3124 11.4163 71.9167 13.0207 71.9167 14.9997L71.9167 84.9997C71.9167 86.9787 70.3124 88.583 68.3333 88.583H31.6667Z"
            fill={fillColor}
          />
        </svg>
      ) : (
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
        >
          <path
            d="M64.8796 22.4671C64.8796 23.2035 64.2826 23.8005 63.5462 23.8005C62.8098 23.8005 62.2129 23.2035 62.2129 22.4671C62.2129 21.7307 62.8098 21.1338 63.5462 21.1338C64.2826 21.1338 64.8796 21.7307 64.8796 22.4671Z"
            fill={fillColor}
          />
          <path
            d="M41.1334 33.3339C41.1334 32.7079 40.626 32.2005 40 32.2005C39.3741 32.2005 38.8667 32.7079 38.8667 33.3339V38.6672C38.8667 39.2931 39.3741 39.8005 40 39.8005C40.626 39.8005 41.1334 39.2931 41.1334 38.6672V33.3339Z"
            fill={fillColor}
          />
          <path
            d="M40.0934 43.9973C39.3588 44.0488 38.7215 43.495 38.67 42.7605C38.6185 42.0259 39.1723 41.3886 39.9069 41.3371C40.6414 41.2856 41.2787 41.8394 41.3302 42.574C41.3817 43.3085 40.8279 43.9458 40.0934 43.9973Z"
            fill={fillColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.5514 24.0365C38.6397 22.2107 41.3603 22.2107 42.4486 24.0365L54.2836 43.8924C55.3719 45.7182 54.0116 48.0005 51.835 48.0005H28.165C25.9884 48.0005 24.6281 45.7182 25.7164 43.8924L37.5514 24.0365ZM40.5016 25.1971L52.3366 45.0529C52.3904 45.1432 52.4009 45.2114 52.3999 45.2636C52.3989 45.3234 52.3811 45.3959 52.3366 45.4706C52.2505 45.615 52.0886 45.7338 51.835 45.7338H28.165C27.9114 45.7338 27.7495 45.615 27.6634 45.4706C27.6189 45.3959 27.6011 45.3234 27.6001 45.2636C27.5991 45.2114 27.6096 45.1431 27.6634 45.0529L39.4984 25.197C39.592 25.04 39.7614 24.9338 40 24.9338C40.2386 24.9338 40.408 25.04 40.5016 25.1971Z"
            fill={fillColor}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.53337 20.0005C9.53337 17.1655 11.8316 14.8672 14.6667 14.8672H65.3334C68.1684 14.8672 70.4667 17.1655 70.4667 20.0005V53.5339H72.8334C74.1036 53.5339 75.1334 54.5636 75.1334 55.8339C75.1334 58.3928 73.059 60.4672 70.5 60.4672H9.50003C6.94111 60.4672 4.8667 58.3928 4.8667 55.8339C4.8667 54.5636 5.89644 53.5339 7.1667 53.5339H9.53337V20.0005ZM33.5334 56.0005C33.5334 55.9323 33.5394 55.8654 33.551 55.8005H7.1667C7.16001 55.8005 7.15407 55.8027 7.15407 55.8027C7.1509 55.804 7.14697 55.8064 7.14313 55.8103C7.13929 55.8141 7.13686 55.8181 7.13552 55.8212C7.13552 55.8212 7.13337 55.8272 7.13337 55.8339C7.13337 57.1409 8.19296 58.2005 9.50003 58.2005H70.5C71.8071 58.2005 72.8667 57.1409 72.8667 55.8339L72.866 55.8269C72.8654 55.8235 72.8645 55.8212 72.8645 55.8212L72.8637 55.8194L72.8602 55.814L72.8569 55.8103C72.8531 55.8064 72.8492 55.804 72.846 55.8027C72.846 55.8027 72.8401 55.8005 72.8334 55.8005H46.4491C46.4607 55.8654 46.4667 55.9323 46.4667 56.0005C46.4667 56.6264 45.9593 57.1339 45.3334 57.1339H34.6667C34.0408 57.1339 33.5334 56.6264 33.5334 56.0005ZM14.6667 17.1339C13.0835 17.1339 11.8 18.4173 11.8 20.0005V53.5339H68.2V20.0005C68.2 18.4173 66.9166 17.1339 65.3334 17.1339H14.6667Z"
            fill={fillColor}
          />
        </svg>
      )}
    </div>
  )
}
